/* eslint-disable react-hooks/exhaustive-deps, no-use-before-define */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import usePush from '../../hooks/usePush';
import { errors } from '../../util/errors';
import LoadingMessage from '../../components/LoadingMessage/index';
import ConnectService from '../../services/connect-service';
import { pendo } from '../../util/logging';
import useQueryParams from '../../hooks/useQueryParams';

// eslint-disable-next-line react/prop-types
const AuthNetsuiteCallback = () => {
  const { code, state: stateParam, company, entity } = useQueryParams();
  const { execute } = usePush(ConnectService.getSubsidiariesNetSuite, {
    errorToast: err => ({
      message: (err.code && errors[err.code]) || 'Sorry, unable to connect to NetSuite',
      autoClose: false,
    }),
  });

  const history = useHistory();
  const apiCall = async () => {
    const [err, data] = await execute({ code, state: stateParam, company, entity });

    if (err || !data) {
      history.push('/');
      return;
    }

    const state = data.state;
    const existing = data.existing;
    const subsidiaries = data.subsidiaries || [];
    const groupSubsidiaries = data.groupSubsidiaries ?? false;

    pendo.track('integration_callback_completed', {
      integration: 'netsuite',
      subsidiaries: subsidiaries.map(({id}) => id),
    });

    return history.push(`/select-organisations/netsuite`, {
      subsidiaries,
      state,
      existing,
      groupSubsidiaries,
    });
  };

  useEffect(() => {
    apiCall();
  }, []);

  return <LoadingMessage center useLogoAnimation />;
};

export default AuthNetsuiteCallback;
